/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Stop_Charging_AfterInputs */

const en_admin_resource_form_stop_charging_after = /** @type {(inputs: Admin_Resource_Form_Stop_Charging_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop charging after`)
};

const de_admin_resource_form_stop_charging_after = /** @type {(inputs: Admin_Resource_Form_Stop_Charging_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht mehr belasten nach:`)
};

const es_admin_resource_form_stop_charging_after = /** @type {(inputs: Admin_Resource_Form_Stop_Charging_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dejar de cargar después de:`)
};

const fr_admin_resource_form_stop_charging_after = /** @type {(inputs: Admin_Resource_Form_Stop_Charging_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrêter la charge après :`)
};

const nl_admin_resource_form_stop_charging_after = /** @type {(inputs: Admin_Resource_Form_Stop_Charging_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop belasten na`)
};

/** @type {(inputs: Admin_Resource_Form_Stop_Charging_AfterInputs) => LocalizedString} */
const it_admin_resource_form_stop_charging_after = en_admin_resource_form_stop_charging_after;

/** @type {(inputs: Admin_Resource_Form_Stop_Charging_AfterInputs) => LocalizedString} */
const pt_br2_admin_resource_form_stop_charging_after = en_admin_resource_form_stop_charging_after;

/** @type {(inputs: Admin_Resource_Form_Stop_Charging_AfterInputs) => LocalizedString} */
const pl_admin_resource_form_stop_charging_after = en_admin_resource_form_stop_charging_after;

/** @type {(inputs: Admin_Resource_Form_Stop_Charging_AfterInputs) => LocalizedString} */
const hu_admin_resource_form_stop_charging_after = en_admin_resource_form_stop_charging_after;

/** @type {(inputs: Admin_Resource_Form_Stop_Charging_AfterInputs) => LocalizedString} */
const ro_admin_resource_form_stop_charging_after = en_admin_resource_form_stop_charging_after;

/**
* | output |
* | --- |
* | "Stop charging after" |
*
* @param {Admin_Resource_Form_Stop_Charging_AfterInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_stop_charging_after = /** @type {((inputs?: Admin_Resource_Form_Stop_Charging_AfterInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Stop_Charging_AfterInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_stop_charging_after(inputs)
	if (locale === "de") return de_admin_resource_form_stop_charging_after(inputs)
	if (locale === "es") return es_admin_resource_form_stop_charging_after(inputs)
	if (locale === "fr") return fr_admin_resource_form_stop_charging_after(inputs)
	if (locale === "nl") return nl_admin_resource_form_stop_charging_after(inputs)
	if (locale === "it") return it_admin_resource_form_stop_charging_after(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_stop_charging_after(inputs)
	if (locale === "pl") return pl_admin_resource_form_stop_charging_after(inputs)
	if (locale === "hu") return hu_admin_resource_form_stop_charging_after(inputs)
	return ro_admin_resource_form_stop_charging_after(inputs)
});
export { admin_resource_form_stop_charging_after as "admin.resource_form.stop_charging_after" }